<template>
  <el-pagination :hide-on-single-page="true" @current-change="$emit('change', $event)"
    @size-change="$emit('size-change', $event)"
    :current-page="currentPage" :page-size="pageSize" :total="total"
    :page-sizes="pageSizes" :layout="layout"
    style="text-align:center;margin-top:16px">
  </el-pagination>
</template>

<script>
export default {
  name: "PageNav",
  props: {
    total: { type: Number, default: 0 },
    currentPage: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    pageSizes: { type: Array, default: () => [10, 20, 30, 40] }
  },
  computed: {
    layout() { return "total, sizes, prev, pager, next, jumper"; }
  }
}
</script>
